<template>
  <div class="global-setting">
    <van-popup ref="settingPopup" :value="show" class="settingPopup" :style="{height:'80vh'}" position="bottom" round safe-area-inset-bottom
               @input="closeSetting">
      <div style="font-weight: bolder;color: var(--primary-color);display: flex;flex-direction: row;justify-content: space-between;align-items: center;padding: 10px 15px;border-bottom: 1px solid var(--border-color);width: 100%">
        <div class="icon-and-title"><i class="iconfont icon-menu"></i>控制台</div>
        <div style="width: 1em;height: 1em" @click="closeSetting">
          <i class="iconfont icon-close"></i>
        </div>
      </div>
      <div  class="settine-content" style="overflow: auto">

        <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;gap: 1em;width: 100%">
          <evan-cell title="回退" v-if="$route.path!=='/'" @click="$router.back()" title-pre-icon="van-icon van-icon-arrow-left">
            <template #preIcon>
              <i class="van-icon van-icon-arrow-left"></i>
            </template>
          </evan-cell>
          <evan-cell title="首页" v-if="$route.path!=='/'" @click="$router.push('/')" title-append-icon="icon-home-house" ></evan-cell>

        </div>
        <evan-cell @click="showWebsiteMap=!showWebsiteMap" title="网站导航">
          <template #appendIcon>
            <div style="display: flex;flex-direction: row;justify-content: flex-end;align-items: center;gap: .5em">
              <evan-switch size=".7em" border-radius="5px" :options="[{label:'cell',value:0},{label:'icon',value:1}]" output-type="value" v-model="routerStyle" border @click.native.stop.prevent></evan-switch>
              <i class="van-icon van-icon-arrow" :style="{rotate:showWebsiteMap?'90deg':'0deg'}" style="transition: rotate .5s"></i>
            </div>
          </template>
          <template #footer>
            <el-collapse-transition>
              <div v-show="showWebsiteMap" style="width: 100%">

                <div  class="settine-content" style="padding:.5em 0 0 0;border-top:1px dashed var(--border-color)">
                    <div v-if="routerStyle===0" style="width: 100%">
                      <van-cell-group v-for="(groupItem,groupIndex) in groupRouteList" v-if="groupItem.children.length>0" :border="false" inset :key="`group_cell_menu__${groupIndex}`" :title="groupItem.group.name">
                        <div  v-for="(item,index) in groupItem.children" :key="`groupItem_${groupIndex}_item__${index}`"  class="van-cell van-cell--borderless" style="padding: 2px;border-radius: inherit" :class="$route.path===item.path?'border-animation-outer':''" :style="{'--borders':'var(--active-color)'}">
                          <van-cell  :border="false" is-link style="width: 100%;background-color: var(--bg-color) !important;border-radius: inherit"  :to="item.path" clickable >
                            <template #title>
                              <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;align-items: center">
                                <div class="icon-and-title">
                                  <i class="iconfont" v-if="item.meta.icon" :class="[item.meta.icon,$route.path===item.path?'active-page':'']"></i>
                                  <div :class="$route.path===item.path?'active-page':''">{{item.meta.name||'未命名页面'}}</div>
                                </div>
                                <div style="height: 100%;display: flex;flex-direction: row;justify-content: center;align-items: center;gap: .5em" >
                                  <van-tag plain type="primary"  v-for="(i,indexes) in item.meta.hasOwnProperty('tag')?item.meta.tag.split(','):[]" :key="`page-view_${index}_tag_${indexes}`" size="small">{{i}}</van-tag>
                                  <van-tag plain type="success"  v-if="$route.path===item.path" >current</van-tag>
                                </div>
                              </div>
                            </template>
                          </van-cell>
                        </div>
                      </van-cell-group>
                    </div>
                    <div v-else style="width: 100%">
                      <div style="display: grid;grid-template-columns: repeat(4,1fr);gap: .5em;width: 100%">
                        <div style="border-radius: .5em;" v-for="(item,index) in routeList" :key="`custom_icon_menu__${index}`" >
                          <div style="display: flex;flex-direction: column;justify-content: flex-start;align-items: center;gap: .2em"    @click="$router.push(item.path)"  >
                            <div style="border-radius: 10px;aspect-ratio: 1/1;display: flex;flex-direction: column;justify-content: center;align-items: center" :class="$route.path===item.path?'border-animation-outer':''" :style="{'--borders':'var(--active-color)'}">
                              <i class="iconfont"  style="font-size: 2em;border-radius: 10px;background-color: var(--table-row-bg);padding: .5em" :class="[item.meta.icon||'icon-menu',$route.path===item.path?'active-page':'']"></i>
                            </div>
                            <div style="font-size: .8em;color: var(--footer-color)" :class="$route.path===item.path?'active-page':''">{{item.meta.name||'未命名'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>


                </div>
              </div>
            </el-collapse-transition>
          </template>
        </evan-cell>
        <evan-cell @click="showIndividuation=!showIndividuation" title="个性化">
          <template #appendIcon>
            <i class="van-icon van-icon-arrow" :style="{rotate:showIndividuation?'90deg':'0deg'}" style="transition: rotate .5s"></i>
          </template>
          <template #footer>
            <el-collapse-transition>
              <div v-show="showIndividuation"  class="settine-content" style="padding:.5em 0 0 0;border-top:1px dashed var(--border-color)">
                <evan-cell title="背景图(试验)">
                  <template #titleAppend>
                    <div v-if="backgroundImage"><van-icon name="delete-o"></van-icon> 查看<van-icon  name="arrow" @click="showBGImage=!showBGImage"></van-icon></div>
                    <div v-else @click="showBGImage=!showBGImage">暂无 <van-icon  name="add-o"></van-icon></div>
                  </template>
                  <template #footer>
                    <el-collapse-transition>
                      <div v-show="showBGImage" style="width: 100%" >
                        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
                          <div style="width: 100%;padding: 0;border: 1px dashed var(--border-color);border-radius: 1em;aspect-ratio: 3/4">
                            <van-uploader style="width: 100%;height: 100%" result-type="dataUrl" v-model="fileList" :deletable="false" :max-count="1" :before-read="beforeReadFile" :after-read="afterReadFile" >
                              <template>
                                <div style="display: flex;flex-direction: column;justify-content: space-around;align-items: center;gap: .5em;padding: 1em;width: 100%;outline: none;box-sizing: border-box;aspect-ratio: 3/4">
                                  <i style="font-size: 30vw;aspect-ratio: 2.35/1" class="iconfont icon-bg"></i>
                                  <div class="el-upload__text">点击上传背景图</div>
                                  <div style="font-size: .7em;color: var(--footer-color)">仅能上传4MB以内，.jpg、.png格式的图片</div>
                                </div>
                              </template>
                            </van-uploader>
                          </div>
                        </div>
                      </div>
                    </el-collapse-transition>
                  </template>
                </evan-cell>
                <evan-cell title="选项样式">
                  <template #titleAppend>
                    <evan-switch style="width: 100%" size=".7em" border border-radius="5px" :options="[{label:'switch开关',value:false},{label:'slider滑块',value:true}]"
                                 output-type="value" v-model="optionType"></evan-switch>
                  </template>
                </evan-cell>
                <evan-cell :title="item.title" v-for="(item,index) in showSwitches" :key="`switch_setting__${index}`" >
                  <template #titleAppend>
                    <evan-switch border border-radius="5px" style="width: 100%" v-if="optionType" size=".8em" :options="[{label:'开启',value:true},{label:'关闭',value:false}]"
                                 output-type="value" :value="$store.state[item.targetName]" @click="changeStoreAndLocalStorage(item.targetName,!$store.state[item.targetName]);"></evan-switch>
                    <van-switch :active-value="true" v-if="!optionType" :inactive-value="false" :value="$store.state[item.targetName]" size="18"
                                @input="changeStoreAndLocalStorage(item.targetName,!$store.state[item.targetName]);"></van-switch>
                  </template>
                  <template #bottom>
                    <div style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;gap: .2em">
                      <van-tag  v-for="(tag,tagIndex) in item.tag.split(',')" size=".5em" :key="`setting_tag__${tagIndex}`">{{tag}}</van-tag>
                    </div>
                  </template>
                </evan-cell>
              </div>
            </el-collapse-transition>
          </template>
        </evan-cell>
        <evan-cell @click="showTool=!showTool" title="工具">
          <template #appendIcon>
            <i class="van-icon van-icon-arrow" :style="{rotate:showTool?'90deg':'0deg'}" style="transition: rotate .5s"></i>
          </template>
          <template #footer>
            <el-collapse-transition>
              <div v-show="showTool"  class="settine-content" style="padding:.5em 0 0 0;border-top:1px dashed var(--border-color)">
                <evan-cell title="生成Token">
                  <template #titleAppend>
                    <van-button :type="canAuth?'primary':'danger'" style="height: 2.5em" :disabled="!canAuth" @click="generateRedisToken" plain>验证并获取</van-button>
                  </template>
                  <template #footer>
                    <el-collapse-transition>
                      <div v-show="showAuthentication">
                        <van-field label="姓名" placeholder="全名" :border="false" clearable line-text v-model="authentication.name"></van-field>
                        <van-field label="电话" placeholder="+86" :border="false" clearable line-text v-model="authentication.phone"></van-field>
                        <van-field label="微信" placeholder="非昵称" :border="false" clearable line-text v-model="authentication.wechat"></van-field>
                      </div>
                    </el-collapse-transition>
                  </template>
                </evan-cell>
              </div>
            </el-collapse-transition>
          </template>
        </evan-cell>
      </div>
    </van-popup>


    <van-dialog v-model="showToken" :confirm-button-text="`关闭`">
        <div style="width: 100%;display: flex;flex-direction: column;justify-content: flex-start;align-items: flex-start;gap: 1em">
          <div style="font-size: .8em;color: var(--negative-color);width: 100%;text-align: center">有效期至：{{tokenInfos.expire|dateformat('yyyy年MM月DD日 HH:mm:ss')}}</div>
          <div @click="copyToken" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width: 100%;border-bottom: .2em dashed var(--active-color)">
            <div style="" v-for="(item,index) in tokenInfos.token" :key="`token__${index}`">{{item}}</div>
          </div>
          <div style="color: var(--footer-color);display: flex;flex-direction:row;justify-content:space-around;align-items: center;width: 100%">
            <van-button type="success" size="small" plain @click="copyToken(true)">仅复制Token</van-button>
            <van-button type="primary" size="small" plain @click="copyToken(false)">直达链接+Token</van-button>
          </div>
        </div>
    </van-dialog>

  </div>
</template>

<script>
import {HandleScroll} from "@/utils/mixin/handleScroll";
import {changeProperty} from "@/utils/global-config";
import {Dialog} from "vant";
import  {LOCAL_STORAGE_KEY, SIZE} from "@/constant/Constants";
import EvanCell from "@/components/EvanCell.vue";
import EvanSwitch from "@/components/EvanSwitch.vue";
import ValidName from "@/utils/ValidName";
import ValidTel from "@/utils/ValidTel";
import {PAGE_GROUP} from "@/router";

export default {
  name: "GlobalSetting",
  components: {EvanSwitch, EvanCell},
  mixins: [HandleScroll],
  model: {  // 新增 model 配置
    prop: 'show',
    event: 'update'
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },

  },
  computed: {
    canAuth() {
      return ValidName.validateName(this.authentication.name).status===0&&ValidTel.validatePhone(this.authentication.phone).status===0&&(this.authentication.wechat.length===0||this.authentication.wechat.length>=6)
    },
    showSwitches() {
      return this.switches.filter(
          item =>
              (typeof item.displayPagePath==='string'?
                  item.displayPagePath===this.$route.path:
                  item.displayPagePath.includes(this.$route.path))
              ||
              !item.displayPagePath)
    },
    groupRouteList() {
      let groupList = [
          {group:PAGE_GROUP.BASIC, children: []},
          {group:PAGE_GROUP.WORK, children: []},
          {group:PAGE_GROUP.MODULE, children: []},
          {group:PAGE_GROUP.UTIL, children: []},
          {group:PAGE_GROUP.RECREATION, children: []},
          {group:PAGE_GROUP.OTHER, children: []},
      ]
      this.$router.getRoutes().forEach(item => {
        if (item.path) {
          if (!item.meta.hasOwnProperty('group')) {
            groupList[groupList.length - 1].children.push(item);
          } else {
            for (let i = 0; i < groupList.length; i++) {

              if (item.meta.group.code === groupList[i].group.code) {
                groupList[i].children.push(item);
                break;
              }
            }
          }
        }
      });
      return groupList;
    },
    routeList() {
      return this.$router.getRoutes().filter(item => item.path && (!item.meta.hasOwnProperty('permission') || item.meta.permission === 'public'));
    },
  },
  data() {
    return {
      logoImage: 'data:image/png;base64,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',
      switches: [
        {title: '显示点击动画', targetName: 'showEffects', displayPagePath: '',tag:'global'},
        {title: '显示备注区域', targetName: 'showRemarks', displayPagePath: ['/bill','/create-order'],tag:'报账单,创建订单'},
        {title: '显示收款码', targetName: 'showQrCode', displayPagePath: ['/bill','/create-order'],tag:'报账单,创建订单'},
        {title: '应用卡片视图', targetName: 'cardType', displayPagePath: '/bill',tag:'报账单专属'},
      ],
      backgroundImage: '',
      showBGImage: false,
      fileList: [],
      routerStyle: 0,
      optionType: true,
      showIndividuation: false,
      showWebsiteMap: false,
      showTool: false,
      showAuthentication: true,
      authentication: {
        name: '',
        phone: '',
        wechat: '',

      },
      showToken: false,
      tokenInfos:{token:'', expire: ''}
    };
  },
  methods: {
    copyToken(onlyToken=true) {
      if (onlyToken) {
        this.$CF.copyText(this.tokenInfos.token, 'Token','',false);
      }else{
        this.$CF.copyText(location.host+'/push-data'+'?token='+this.tokenInfos.token, 'Token','',false);
      }
    },
    generateRedisToken() {
      this.$request.basic.generateRedisToken(this.authentication).then(res =>{
        if (res.state === 20000) {
          this.tokenInfos = res.data;
          this.showToken = true;
        }else{
          console.log(res)
          Dialog({
            title:`CODE：${res.state}`,
            message:`<div style="text-align: left">${res.message}</div>`,
            allowHtml:true,
          })
        }
      }).catch(cat =>{
        console.log("错误,",cat)
      })
    },
    afterReadFile(file, detail) {
      console.log('after',file, detail);
      const base64 = file.content;
      localStorage.setItem(LOCAL_STORAGE_KEY.bg, base64);
      this.payQrImage = base64;
      this.hasImage = true;
      this.fileList = [];
    },
    beforeReadFile(file, detail) {
      console.log('before',file, detail);
      // 检查文件类型和大小
      if (!file.type.match('image/jpeg') && !file.type.match('image/png')) {
        Dialog.confirm({message:`文件类型限制为JPG/PNG\n当前文件类型为：${file.type?file.type:'未知类型'}！`,theme:'round',showCancelButton:false})
        return false;
      }
      if (file.size > (SIZE.MB(4))) {
        console.log('大于')
        Dialog.confirm({message:`图片限制为4MB\n当前图片大小为：${(file.size/1024/1024).toFixed(2)}MB！`,theme:'round',showCancelButton:false})
        return false;
      }
      return file;
    },
    changeStoreAndLocalStorage(key, value) {
      changeProperty(this, undefined, key, value);
    },
    closeSetting() {
      this.$emit('update', false)
    },
  }, mounted() {

  }, watch: {

  }
}
</script>

<style scoped lang="scss">
.settingPopup{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.settine-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: .5em;
}
.row-setting {
  width: 100%;
  outline: none;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: .5em;
  padding: .5em 1em;
  border-radius: .5em;
  border: 1px solid var(--border-color);

  background-color: var(--input-bg);
}
.setting_columns {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: .3em;
  width: 100%;
}

.setting__field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: .3em;
}
.gradient-letter {
  /* 设置渐变背景 */
  background: linear-gradient(135deg,
      #6ecbf5 0%,
      #4ab3f2 20%,
      #2a8fdb 40%,
      #0d6bc9 60%,
      #0649a3 80%,
      #022e6d 100%);

  /* 将背景裁剪到文本区域 */
  -webkit-background-clip: text;
  background-clip: text;
  font-size: 2em;
  /* 使文本透明以显示背景 */
  color: transparent;

  /* 添加阴影增强效果 */
  text-shadow: 0 5px 15px rgba(2, 46, 109, 0.3);
}


.active-page {
  font-weight: 600;
  //transition: color,background-color 2s;
  animation: active-page__sign 3s ease  infinite;
}
@keyframes active-page__sign {
  0%,100% {
    color: var(--active-color);
  }
  50%{
    color: var(--positive-color);
  }

}
</style>
